<div class="{{activeTemplate}} side-buttons">
    <!-- <div class="button button_chat" (click)="showChat()"></div> -->
    <div class="button button_up m-t-xs-smaller" (click)="scrollTop()"></div>
</div>